<template>
  <div class="">
    <div v-if="column == 'installation_name'">
      <b>{{ item.installation_name }}</b>
      <small v-if="isAdmin" class="red--text ml-2">
        <br>
        {{ getAdminLabel }}
      </small>
    </div>
    <div v-else-if="column.includes('_evo')">
      <b>{{ getPercent }}%</b>
      <v-icon class="ml-2" v-text="getEvoArrowType" :class="getEvoArrowClass"></v-icon>
    </div>
    <div v-else-if="['potential'].includes(column)">
      <span>{{ getPercent }}%</span>
    </div>
    <div v-else-if="['action_list'].includes(column)">
        <div v-for="(action, index) in item[column]" :key="index" class="text-capitalize">
            {{action}}
        </div>
        <div v-if="!item[column] || !item[column].length">
          Aucun
        </div>
    </div>
    <div v-else-if="column.includes('kWc')">
      <span>{{ item[column] }}kWc</span>
    </div>
    <div v-else-if="column.includes('_date')">
      {{ parseDate(item[column]) }}
    </div>
    <div v-else>
      {{ item[column] }}
    </div>
  </div>
</template>

<script>
export default {
  props: {
    item: {
      required: true,
    },
    column: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      isAdmin: this.getRole() === 'admin',

      degreesArrows: {
        constant: 1,
        half: 4.99,
        max: 5,
      },

      degreesBackgrounds: {
        pr: {
          red: 70,
        },
        ip: {
          red: 85,
          orange: 94.99,
          green: 95
        },
      }

    };
  },
  methods: {
    getRole() {
      return this.$store.state.authStore.role
    },

    parseDate(dt) {
      if (dt !== undefined) {
        const splitted = dt.split('-')
        if (splitted.length < 3) return dt
        return `${splitted[2]}-${splitted[1]}-${splitted[0]}`
      } else {
        return ''
      }
    },
  },

  computed: {
    getPercent() {
      return Math.floor(this.item[this.column]);
    },

    getEvoArrowClass(){
        switch (this.getEvoArrowType) {
            case 'mdi-arrow-up': return 'green--text'
            case 'mdi-arrow-down': return 'red--text'
            case 'mdi-arrow-top-right': return 'green--text'
            case 'mdi-arrow-bottom-right': return 'orange--text'
            default: return ''
        }
    },

    getBackgroundClass() {
      const degreesBackground = this.degreesBackgrounds[this.column];
      const value = this.getPercent
      const spacingClasses = '' // px-6 py-6 ml-n4
      
      if(value<degreesBackground.red) 
        return `red-field ${spacingClasses}`
      if(degreesBackground.orange && value<degreesBackground.orange)
        return `orange-field ${spacingClasses}`
      if(degreesBackground.green)
        return `green-field ${spacingClasses}`
      return spacingClasses
    },

    getEvoArrowType() {
      let arrowType = "max";
      if (
        -this.degreesArrows.constant <= this.getPercent &&
        this.degreesArrows.constant >= this.getPercent
      )
        arrowType = "constant";
      else if (
        (-this.degreesArrows.constant >= this.getPercent &&
          -this.degreesArrows.half <= this.getPercent) ||
        (this.degreesArrows.constant <= this.getPercent &&
          this.degreesArrows.half >= this.getPercent)
      )
        arrowType = "half";

      if (arrowType == "constant") return "mdi-arrow-right";
      else {
        if (arrowType == "half")
          return this.getPercent > 0
            ? "mdi-arrow-top-right"
            : "mdi-arrow-bottom-right";
        else return this.getPercent > 0 ? "mdi-arrow-up" : "mdi-arrow-down";
      }
    },

    getAdminLabel() {
      if (this.item.compute_end_date !== undefined) {
        return `Id: ${this.item.id} - Computed: ${this.item.compute_end_date}`
      } else {
        return `Id : ${this.item.id}`
      }
    }

  },

  method : {
    getAdminLabel() {
      console.log(this.item.compute_end_date)
      // if (this.item.compute_end_date !== undefined) {
      //   return `Id : ${this.item.id}, Computed @${this.item.compute_end_date}`
      // } else {
      //   return `Id : ${this.item.id}`
      // }
    }
  }
};
</script>

<style scoped>
  td > div {
    height: 100%;
    width: 100%;
    text-align: left;
    display: flex;
    justify-content: left;
    align-items: center;
  }

  .red-field {
    background-color: #ffaaa7;
  }

  .orange-field {
    background-color: #ffd3b4;
  }

  .green-field {
    background-color:  #d5ecc2;
  }
</style>
